import { throttle } from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './assets/css/tailwind.css';
import App from './components/App';
import store from './redux/configureStore';
import { persistRecentlyViewedObjectIds } from './redux/modules/data/objectsSlice';
import { persistFavoriteLists } from './redux/modules/favoritesSlice';
import { persistActiveLanguage } from './redux/modules/data/localizationSlice';
import { persistEvaluations } from './redux/modules/evaluationsSlice';

store.subscribe(throttle(() => {
	persistRecentlyViewedObjectIds({
		recentlyViewedObjectIds: store.getState().objects.recentlyViewedObjectIds,
	});
	persistFavoriteLists({
		favoriteLists: store.getState().favorites.favoriteLists,
	});
	persistActiveLanguage({
		activeLanguageId: store.getState().localization.activeLanguageId,
	});
	persistEvaluations({
		evaluations: store.getState().evaluations.all,
		backedUpEvaluationIds: store.getState().evaluations.backedUpEvaluationIds,
	});
}, 1000));

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<App />
		</Provider>
	</React.StrictMode>,
	document.getElementById('root'),
);
